import { yupResolver } from "@hookform/resolvers/yup"
import React, { useState, useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Spinner,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import { UFInput } from "../../../components/Common/Fields/Input"
import classnames from "classnames"
import closeIcon from "../../../assets/icons/close.svg"
import { Link } from "react-router-dom"
import {
  fetchSingleBank,
  postBanks,
} from "../../../services/Inventory/inventory"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import StateOnlyList from "../../../components/Common/chooseFields/stateonlyLi"
import FinanceGroupType from "../../../components/Common/chooseFields/financeGroupType"
import EditFinanceGroup from "../../Finance/groups/edit"

const schema = yup.object().shape({
  state: yup.mixed().required("State / Emirate is Required"),
  name: yup.string().required("Bank Name is Required"),
  account_group_id: yup.mixed().required("Nature of Account is Required"),
  // iban_code: yup.string().required("IBAN Code is Required"),
  // swift_code: yup.string().required("Swift Code is Required"),
})

const Edit = ({ loading, onUpdate, id, error, close, ...props }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })
  const [isLoading, setIsLoading] = useState(false)

  const [showGroupModal, setShowGroupModal] = useState(false)
  useEffect(() => {
    console.log(`props?.editItem`, props?.editItem)
    if (props?.editItem?.modal) {
      const fetchData = async id => {
        const response = await fetchSingleBank(id)
        reset({
          ...response?.data,
          state: {
            value: response?.data?.state?.id,
            label: response?.data?.state?.name,
          },
          account_group_id: response?.data?.ledger?.account_group?.id
          ? {
              value: response?.data?.ledger?.account_group?.id,
              label: response?.data?.ledger?.account_group?.name,
            }
          : null,
        })
        console.log(`response`, response)
      }
      fetchData(props?.editItem?.value?.id)
    }
  }, [props?.editItem?.modal])

  const handleCategoryAdd = async data => {
    try {
      setIsLoading(true)
      const createdCategory = await postBanks({
        ...data,
        state: data?.state?.value,
        account_group_id: data?.account_group_id?.value,
      })
      toastSuccess(createdCategory?.message)
      onUpdate()
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      reset()
      close()
    }
  }

  useEffect(() => {
    if (watch("designation_id") && !props?.editItem?.modal) {
      setValue("description", watch("designation_id")?.name)
    }
  }, [watch("designation_id")])

  return (
    <>
      <ModalHeader className="custom-modal-header">
        <div className="d-flex justify-content-between">
          <h5>{props?.editItem?.modal ? "Edit Bank" : "Add Bank"}</h5>{" "}
          <img
            src={closeIcon}
            alt=""
            onClick={close}
            width="10"
            role="button"
          />
        </div>
      </ModalHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="lg"
          />
        </div>
      ) : (
        <>
          <ModalBody>
            <FormProvider {...methods}>
              <Form id={`ev-form`} onSubmit={handleSubmit(handleCategoryAdd)}>
                <Row>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Bank Name<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        name={"name"}
                        placeholder="Enter Bank Name"
                        // disabled={props?.editItem?.modal ? true : false}
                      />
                      <FormFeedback invalid>
                        {errors.name?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup>
                      <Label>
                        Nature Of Account
                        <span className="mandatory">*</span>
                      </Label>
                      <FinanceGroupType
                        control={control}
                        placeholder="Select the Nature Of Account"
                        name={"account_group_id"}
                        invalid={!!errors.account_group_id}
                        target={"body"}
                        showCreateOption={true}
                        onCreate={() => setShowGroupModal(true)}
                        // onSelectChange={e => handleNOA(e)}
                        refreshKey={showGroupModal}
                        parentChk={"5"}
                      />
                      <EditFinanceGroup
                        buttonLabel=""
                        className=""
                        show={showGroupModal}
                        onReset={() => setShowGroupModal(false)}
                        onUpdate={newGroup => {
                          setShowGroupModal(false)
                          if (newGroup) {
                            setValue(
                              "account_group_id",
                              {
                                label: newGroup.name,
                                value: newGroup.id,
                              },
                              { shouldValidate: true }
                            )
                          }
                        }}
                      />
                      <FormFeedback invalid>
                        {errors.account_group_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>IBAN Code</Label>
                      <UFInput
                        control={control}
                        name={"iban_code"}
                        placeholder="Enter IBAN Code"
                        // seriesId={watch("series_id")}
                        // disabled={props?.editItem?.modal ? true : false}
                      />
                      <FormFeedback invalid>
                        {errors.iban_code?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>Swift Code</Label>
                      <UFInput
                        control={control}
                        name={"swift_code"}
                        placeholder="Enter Swift Name"
                        // disabled={props?.editItem?.modal ? true : false}
                      />
                      <FormFeedback invalid>
                        {errors.swift_code?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        State / Emirate<span className="mandatory">*</span>
                      </Label>
                      <StateOnlyList
                        control={control}
                        placeholder="select"
                        name={"state"}
                        dropView={true}
                        // selectedCountry={watch("country_id")}
                      />
                      <FormFeedback invalid>
                        {errors.state?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </ModalBody>
          <ModalFooter>
            <LoadingButton
              form={`ev-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {props?.editItem?.modal ? "Update" : "Save"}
            </LoadingButton>
          </ModalFooter>
        </>
      )}
    </>
  )
}

const EditBanks = ({ buttonLabel, className, ...props }) => {
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  useEffect(() => {
    if (props?.editItem?.modal) {
      toggle()
    }
  }, [props?.editItem?.modal])

  return (
    <>
      <Link to="#" className={className} onClick={toggle}>
        {buttonLabel}
      </Link>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <Edit
          close={() => {
            setModal(false)
            props?.onReset()
          }}
          {...props}
        />
      </Modal>
    </>
  )
}

export default EditBanks
